/* eslint-disable */
import React, { Fragment, useRef, useEffect } from "react";
import { Field } from 'formik';
import ErrorMessage from "../ErrorMessage"
import Select from "react-select";
import CreatableSelect from "react-select/creatable"
import {
    Label
  } from "reactstrap"


const SelectInput = (props) => {

    const { 
      field,
      form: { setFieldValue, errors, isSubmitting, isValidating},
      label,
      isLoading,
      isClearable,
      isDisabled,
      labelCustomClass,
      isMultiSelect,
      onChange,
      customClass,
      customLabel,
      placeholder,
      customId,
      options,
      closeMenuOnSelect,
      isRequired,
      onInputChange,
      isCreatable
    } = props;


    const keys = Object.keys(errors);
    const ObjectType = keys && (typeof errors[keys[0]] === 'object')
    const data = keys && errors[keys[0]] && ObjectType && Object.keys(errors[keys[0]])
      const selectRef = useRef(null)

    useEffect(() => {
      if (keys.length > 0 && isSubmitting && !isValidating) {
        const selector = ObjectType ? `${keys[0]}.${data[0]}` : `${keys[0]}`;
        if (selector === `${field.name}`) {
          selectRef.current && selectRef.current.focus();
        }
      }
    })
    return (
        <Fragment>
        <Label for={label} className={labelCustomClass}>{label}{isRequired && (<span className="text-danger font-medium-3 lh-1">&#42;</span>)}</Label>
        {isCreatable ? (
          <CreatableSelect
          className={`React ${customClass}`}
          color="primary"
          maxMenuHeight={300}
          classNamePrefix="select"
          options={options}
          menuPortalTarget={document.body} 
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          closeMenuOnSelect={closeMenuOnSelect}
          placeholder='Select'
          // getOptionLabel={(option) => { return option.name }}
          // getOptionValue={(option) => { return option.id }}
          isMulti={isMultiSelect}
          name={field.name}
          value={field.value || null}
          onInputChange={onInputChange}
          defaultValue={field.value || null}
          onChange={(option) => { setFieldValue(field.name, option); if (onChange) onChange(option); }}
          isDisabled={isDisabled}
          isClearable={isClearable}
          isLoading={isLoading}
          ref={selectRef}
        />
        ) : (
        <Select
          className={`React ${customClass}`}
          color="primary"
          maxMenuHeight={300}
          classNamePrefix="select"
          options={options}
          menuPortalTarget={document.body} 
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          closeMenuOnSelect={closeMenuOnSelect}
          placeholder='Select'
          getOptionLabel={(option) => { return customLabel ? option[customLabel] : option.name; }}
          getOptionValue={(option) => { return customId ? option[customId] : option.id; }}
          isMulti={isMultiSelect}
          name={field.name}
          value={field.value || null}
          defaultValue={field.value || null}
          onChange={(option) => { setFieldValue(field.name, option); if (onChange) onChange(option); }}
          isDisabled={isDisabled}
          isClearable={isClearable}
          isLoading={isLoading}
          ref={selectRef}
        />
      )}
      </Fragment>
       )
    }

const SelectBox = (props) => {
    const {
        name,
        onChange,
        customClass,
        isLoading,
        isClearable,
        isDisabled,
        closeMenuOnSelect,
        customLabel,
        placeholder,
        labelCustomClass,
        onClick,
        errorLabel,
        label,
        onInputChange,
        options,
        isMultiSelect,
        defaultChecked,
        disabled,
        customId,
        customIcon,
        isCreatable,
        isRequired
    } = props;
    return (
      <div className="w-100">
        <Field
        component={SelectInput}
        errorLabel={errorLabel}
        customClass={customClass}
        labelCustomClass={labelCustomClass}
        name={name}
        closeMenuOnSelect={closeMenuOnSelect}
        placeholder={placeholder}
        options={options}
        customLabel={customLabel}
        isCreatable={isCreatable}
        customId={customId}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isLoading={isLoading}
        label={label}
        customIcon={customIcon}
        onChange={onChange}
        onClick={onClick}
        disabled={disabled}
        isMultiSelect={isMultiSelect}
        defaultChecked={defaultChecked}
        isRequired={isRequired}
        onInputChange={onInputChange}
        />
         <ErrorMessage name={name} className="field-error text-danger" />
      </div>
    );
  };
  
  export default SelectBox;